import { ELocalStorageKeys } from "constants/enums";
import { UserDetails } from "pages/Login/Login.types";

import { localStorageUtil } from "./localStorageUtil";

export const getPublisherId = () => {
    return localStorageUtil.get(ELocalStorageKeys.USER_DETAILS).publisherId;
}